import { NAME as FUSE_NAME } from '../constants';

export const NAME = `${FUSE_NAME}/PAYMENTS`;
export const REDUCER_NAME = 'payments';
export const BOOKING_STEPS = {
  NEW: 'NEW',
  TOKENIZATION: 'TOKENIZATION',
  AUTHORIZATION: 'AUTHORIZATION',
  CONFIRMATION: 'CONFIRMATION',
  SD3: 'SD3',
  BOOKING: 'BOOKING',
  BOOKED: 'BOOKED',
  FAILED: 'FAILED',
};
